import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=0b50be41&scoped=true&lang=pug"
import script from "./Plan.vue?vue&type=script&lang=js"
export * from "./Plan.vue?vue&type=script&lang=js"
import style0 from "./Plan.vue?vue&type=style&index=0&id=0b50be41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50be41",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrugsMonthlyByDrug: require('/home/docker/code/frontend/components/DrugsMonthlyByDrug.vue').default,PlanProvidersList: require('/home/docker/code/frontend/components/PlanProvidersList.vue').default})
